<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Trash Executive</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>UserId</th>
                            <th>Executive Name</th>
                            <th>Mobile</th>
                            <th>Address</th>
                            <th>Modify</th>
                        </tr>
                        <tr v-for="(employee_master,i) in employee_masters.data" :key="employee_master.BANK_ID">
                            <td>{{ i+1 }}</td>
                            <td> {{ employee_master.Employee_User_Id}} </td>
                            <td> {{ employee_master.Employee_First_Name}} {{ employee_master.Employee_Last_Name}} </td>
                            <td>{{ employee_master.Employee_Mobile_Number }}</td>
                            <td>{{ employee_master.Employee_Address }}</td>
                            <td>
                                <a href="#" @click="restoreEmployee(employee_master.EMPLOYEE_ID)"><i class="fas fa-recycle green"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="employee_masters" @pagination-change-page="loadAndSearchTrashEmployee" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchTrashEmployee(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                search:'',
                employee_masters:{},
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchTrashEmployee();
            })
            Fire.$on('AfterChangeEmployee',()=>{
                this.loadAndSearchTrashEmployee();
            });
        },
        mounted(){
            this.loadAndSearchTrashEmployee();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            restoreEmployee(EMPLOYEE_ID){
                Swal.fire({
                    title: 'Are you sure Restore It?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, do it!'
                    }).then((result) => {
                        if(result.value){
                            axios.get('restoreEmployee/'+EMPLOYEE_ID).then(()=>{
                                Fire.$emit('AfterChangeEmployee');
                                this.toast.$emit('SwalSuccess',"success !", "Employee restore successfully.");

                            }).catch(()=>{
                                this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Employee Is Already In Use");
                            })
                        }
                    })
            },
            loadAndSearchTrashEmployee(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchTrashEmployee?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.employee_masters = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
